import { useRef } from "react";

const Project: React.FC<{ title: string; description: string, url: string, projectImg: string, projectVideo: string }> = (props) => {

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleMouseEnter = () => {
    if (!videoRef.current) return;
    videoRef.current.currentTime = 0;
    videoRef.current.play();
  };

  const handleMouseLeave = () => {
    if (!videoRef.current) return;
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
  };

  return (

    <div className="flex flex-col sm:flex-row items-center justify-between p-6  text-white rounded-lg ">
      <div className="flex-shrink-0 mb-4 sm:mb-0 sm:mr-6">
        <video
          ref={videoRef}
          muted
          loop
          playsInline
          preload="none"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="  w-full
          max-w-lg
          aspect-video
          rounded-xl
          shadow-lg
          object-cover
          will-change-transform
          transition-transform
          duration-300
          ease-out
          hover:scale-[1.03]"
          poster={props.projectImg}
        >
          <source src={props.projectVideo} type="video/mp4" />
        </video>
      </div>
      <div className="flex-grow">
        <h2 className="text-2xl font-bold mb-2">{props.title}</h2>
        <p className="text-lg mb-4">
          {props.description}
        </p>
        <a
          href={props.url}
          target="_blank"
          className="inline-block bg-cyan-500 text-white py-2 px-4 rounded-lg shadow hover:bg-cyan-600 transition"
        >
          View Project
        </a>
      </div>
    </div>

  );
};

export default Project;
